import { Fragment, useState, useCallback } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Switch } from '@headlessui/react';

const defaultTemplate = `
<div style="max-width: 600px; margin: 0 auto; font-family: Arial, sans-serif;">
  <!-- Top Banner -->
  <div style="background-color: #000; color: white; text-align: center; padding: 10px;">
    شحن مجاني على جميع الطلبات فوق 100$
  </div>

  <!-- Logo -->
  <div style="text-align: center; padding: 20px;">
    <img src="https://i.ibb.co/YkwGqLQ/Screenshot-2024-11-14-at-3-38-45-PM-removebg-preview-1.png" alt="SellAbroad" style="height: 50px;">
  </div>

  <!-- Main Heading -->
  <div style="text-align: center; margin: 20px 0;">
    <h1 style="margin: 0; font-size: 24px;">عروض حصرية لعيد الشكر تبدأ قريباً!</h1>
    <p style="margin: 10px 0;">احتفل بموسم الامتنان مع صفقات شهية. عروضنا المختارة للعطلات على وشك الوصول - لا تفوت فرصة التوفير!</p>
  </div>

  <!-- CTA Button -->
  <div style="text-align: center; margin: 20px 0;">
    <a href="#" style="background-color: #000; color: white; padding: 10px 30px; text-decoration: none; border-radius: 5px;">
      اكتشف ما هو قادم
    </a>
  </div>

  <!-- Product Grid -->
  <div style="display: flex; justify-content: space-between; margin: 30px 0;">
    <div style="width: 48%; text-align: center;">
      <img src="https://i.ibb.co/82xMFc1/NOV002-2-07abbaea-3e7d-4c61-8034-9d6593ae1833-1080x.webp" alt="Product 1" style="width: 100%; margin-bottom: 10px;">
      <h3 style="margin: 10px 0;">طقم أواني الطهي للمناسبات</h3>
      <div style="margin: 10px 0;">
        <span style="text-decoration: line-through; color: #999;">35.00$</span>
        <span style="font-weight: bold; margin: 0 10px;">20.00$</span>
        <span style="color: green;">وفر 15.00$</span>
      </div>
      <button style="border: 1px solid #000; padding: 5px 20px; background: none; cursor: pointer;">
        تسوق الآن
      </button>
    </div>
    <div style="width: 48%; text-align: center;">
      <img src="https://i.ibb.co/82xMFc1/NOV002-2-07abbaea-3e7d-4c61-8034-9d6593ae1833-1080x.webp" alt="Product 2" style="width: 100%; margin-bottom: 10px;">
      <h3 style="margin: 10px 0;">طقم أواني الطهي للمناسبات</h3>
      <div style="margin: 10px 0;">
        <span style="text-decoration: line-through; color: #999;">30.00$</span>
        <span style="font-weight: bold; margin: 0 10px;">15.00$</span>
        <span style="color: green;">وفر 15.00$</span>
      </div>
      <button style="border: 1px solid #000; padding: 5px 20px; background: none; cursor: pointer;">
        تسوق الآن
      </button>
    </div>
  </div>

  <!-- Bottom Banner -->
  <div style="background-color: #000; color: white; text-align: center; padding: 15px; margin: 20px 0;">
    استخدم كود الخصم: 25OFF
  </div>

  <!-- Footer -->
  <div style="text-align: center; margin: 20px 0;">
    <img src="https://i.ibb.co/YkwGqLQ/Screenshot-2024-11-14-at-3-38-45-PM-removebg-preview-1.png" alt="SellAbroad" style="height: 40px; margin-bottom: 10px;">
    <div style="margin: 10px 0;">اسم الشركة</div>
    <div style="margin: 10px 0;">
      <a href="#" style="color: #666; text-decoration: none; margin: 0 10px;">انستغرام</a>
      <a href="#" style="color: #666; text-decoration: none; margin: 0 10px;">فيسبوك</a>
      <a href="#" style="color: #666; text-decoration: none; margin: 0 10px;">بينتريست</a>
      <a href="#" style="color: #666; text-decoration: none; margin: 0 10px;">تيك توك</a>
    </div>
    <div style="color: #666;">www.yourcompany.com</div>
  </div>
</div>
`;

export default function EmailBuilderModal({ isOpen, onClose }) {
  const [htmlContent, setHtmlContent] = useState(defaultTemplate);
  const [prompt, setPrompt] = useState('');
  const [options, setOptions] = useState({
    swapColors: false,
    swapCopy: false,
    swapImages: false,
    swapProducts: false,
    swapFonts: false,
    swapButtons: false
  });

  const toggleOption = (option) => {
    setOptions(prev => ({
      ...prev,
      [option]: !prev[option]
    }));
  };

  const handleSubmit = () => {
    // TODO: Save the email template
    onClose();
  };

  const handleGenerate = () => {
    // TODO: Generate email based on prompt and options
    console.log('Generating email with prompt:', prompt, 'and options:', options);
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl">
                <div className="flex flex-col h-[800px]">
                  {/* Header */}
                  <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <h2 className="text-lg font-semibold">Email Builder</h2>
                    <div className="flex items-center space-x-4">
                      <button
                        onClick={handleSubmit}
                        className="px-4 py-2 text-sm font-medium text-white bg-[#0049ac] rounded-md hover:bg-[#0049ac]/90"
                      >
                        Save Template
                      </button>
                    </div>
                  </div>

                  {/* Main Content */}
                  <div className="flex flex-1 overflow-hidden">
                    {/* Email Preview */}
                    <div className="w-2/3 bg-gray-100">
                      <div className="h-full p-4 overflow-auto">
                        <div 
                          className="bg-white mx-auto"
                          dangerouslySetInnerHTML={{ __html: htmlContent }}
                        />
                      </div>
                    </div>

                    {/* Right Panel - Prompt and Options */}
                    <div className="w-1/3 border-l border-gray-200 p-6">
                      {/* Prompt Section */}
                      <div className="mb-8">
                        <h3 className="text-lg font-medium mb-4">Prompt</h3>
                        <textarea
                          value={prompt}
                          onChange={(e) => setPrompt(e.target.value)}
                          placeholder="Make me an email..."
                          className="w-full h-32 rounded-lg border-gray-300 focus:border-[#0049ac] focus:ring-[#0049ac]"
                        />
                        <button
                          onClick={handleGenerate}
                          className="w-full mt-4 px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90"
                        >
                          Generate
                        </button>
                      </div>

                      {/* Options Section */}
                      <div>
                        <h3 className="text-lg font-medium mb-4">Options</h3>
                        <div className="space-y-4">
                          {Object.entries({
                            'Swap colors': 'swapColors',
                            'Swap copy': 'swapCopy',
                            'Swap images': 'swapImages',
                            'Swap products': 'swapProducts',
                            'Swap fonts': 'swapFonts',
                            'Swap buttons': 'swapButtons'
                          }).map(([label, key]) => (
                            <div key={key} className="flex items-center justify-between">
                              <span className="text-gray-700">{label}</span>
                              <Switch
                                checked={options[key]}
                                onChange={() => toggleOption(key)}
                                className={`${
                                  options[key] ? 'bg-[#0049ac]' : 'bg-gray-200'
                                } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none`}
                              >
                                <span
                                  className={`${
                                    options[key] ? 'translate-x-6' : 'translate-x-1'
                                  } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                                />
                              </Switch>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}